import { useState, useCallback } from "react";

const useVanityModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModal = useCallback((content) => {
    setModalContent(content ?? null);
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
    setModalContent(null);
  }, []);

  return {
    modalOpen,
    modalContent,
    openModal,
    handleCloseModal,
  };
};

export default useVanityModal;
